// This file contains constants for progen related files in the vendor app

// Define the app names constant
export const APP_NAMES = {
  HUBSPOT: 'hubspot', // App name for HubSpot
};

export const TAB_NAMES_MAP = {
  signature: 'sendForSignature',
  installment: 'offerInstallment',
  defer: 'deferPayment',
  fmv: 'fmvLeasing',
};

export const TAB_NAME_LABELS_MAP = {
  // Each tab name maps to a label object with different sizes ('small' and 'default')
  // The 'fallback' is used for label based conditional rendering
  sendForSignature: {
    fallback: 'signature',
    small: 'eSignature',
    default: 'eSignature',
  },
  offerInstallment: {
    fallback: 'installment',
    small: 'Installments',
    default: 'Installment plan',
  },
  deferPayment: {
    fallback: 'defer',
    small: 'Deferral',
    default: 'Defer payment',
  },
  fmvLeasing: {
    fallback: 'leasing',
    small: 'Leasing',
    default: 'FMV leasing',
  },
};

export const PAYOUT_LABELS = {
  availableAmount: {
    small: 'Ava. amt',
    medium: 'Ava. amount',
    default: 'Available amount',
  },
  maxSubsidy: {
    small: 'Max sub.',
    default: 'Max Subsidy',
  },
};

// add more here as per usage
export const APPRAISAL_STATES = {
  DECLINED: 'DECLINED',
  APPROVED: 'APPROVED',
  NEED_INFORMATION: 'NEED INFORMATION',
  REQUEST_IN_REVIEW: 'REQUEST IN REVIEW',
  CREDIT_IN_REVIEW: 'CREDIT IN REVIEW',
  EXPIRED: 'EXPIRED',
};

export const STATUS_PILLS_COMPACT_TEXT = {
  REQUEST_IN_REVIEW: 'IN REVIEW',
};

export const RESEND_SIGNATURE_LINK_STATES = [
  'signatures',
  'incumbency_signatures',
  'corporate_guarantee',
];
